import {FC, useState, useEffect} from 'react'

type Props = {
  radioButton: boolean
  title: string
  desc: string
  file: string
  onSelectedRadio: any
  onInputNote: any
  name: string
  data: any
  errors: any
  fieldRefs: any
  anotherName: string
}

const TypeProposalContent: FC<Props> = ({
  radioButton,
  title,
  desc,
  file,
  onSelectedRadio,
  onInputNote,
  name,
  data,
  errors,
  fieldRefs,
  anotherName,
}) => {
  const [selected, setSelected] = useState<any>({
    id: '',
    name: '',
  })

  const [dataNote, setDataNote] = useState<any>({
    name: '',
    value: '',
  })

  useEffect(() => {
    setSelected({
      id: data?.[name] ?? '',
      name: name,
    })

    setDataNote({
      name: `catatan_${name}`,
      value: data?.[`catatan_${name}`] ?? '',
    })
  }, [data])

  const selectedRadio = (id: any, name: string) => {
    let data = {
      id: id,
      name: name,
    }

    onSelectedRadio(data)
    setSelected(data)
  }

  const inputNote = (value: any, name: any) => {
    let data = {
      name: name,
      value: value,
    }

    setDataNote(data)
    onInputNote(data)
  }

  return (
    <>
      <div
        className={`p-3 d-flex justify-content-between align-items-center border rounded ${
          errors?.[name] && 'border-danger'
        }`}
        style={{backgroundColor: '#F4F7FE', cursor: 'pointer'}}
        onClick={() => (radioButton || !file ? null : window.open(`${file}`, '_blank'))}
        ref={fieldRefs?.[name]}
      >
        {/* KIRI */}
        <div
          className='d-flex align-items-start flex-grow-1'
          onClick={() => (!radioButton || !file ? null : window.open(`${file}`, '_blank'))}
        >
          <i className='fas fa-file-alt fa-lg me-3 mt-3 text-dark'></i>
          <div>
            <strong>{title}</strong>{' '}
            {file ? null : (
              <span className='text-danger' style={{fontSize: '10px'}}>
                (Tidak ada file)
              </span>
            )}
            <br />
            {desc}
          </div>
        </div>

        {/* KANAN */}
        {radioButton ? (
          <div className='d-flex align-items-center custom-radio'>
            <div className='form-check me-4'>
              <input
                className='form-check-input custom-radio-input'
                type='radio'
                value={1}
                checked={selected?.id == 1 && selected?.name == name ? true : false}
                onChange={() => selectedRadio(1, name)}
              />
              <label className='form-check-label' htmlFor='iya'>
                Iya
              </label>
            </div>

            <div className='form-check'>
              <input
                className='form-check-input custom-radio-input'
                type='radio'
                value={0}
                checked={selected?.id === 0 && selected?.name == name ? true : false}
                onChange={() => selectedRadio(0, name)}
              />
              <label className='form-check-label' htmlFor='tidak'>
                Tidak
              </label>
            </div>
          </div>
        ) : null}
      </div>
      {(errors?.[name] || errors?.[`catatan_${name}`]) && (
        <p className='text-danger'>{errors?.[name] ?? errors?.[`catatan_${name}`]}</p>
      )}

      {radioButton && selected?.id === 0 && (
        <div
          className='my-5'
          ref={fieldRefs?.[`catatan_${name}`] || fieldRefs?.[`catatan_${anotherName}`]}
        >
          <p className='mb-1'>
            Alasan Tidak Memenuhi Kriteria <span className='text-danger fw-bold'>*</span>
          </p>
          <textarea
            rows={5}
            className={`form-control custom-placeholder ${
              errors?.[`catatan_${name}`] || (errors?.[`catatan_${anotherName}`] && 'border-danger')
            }`}
            placeholder='Masukan Alasan Tidak Memenuhi Kriteria'
            onChange={(e) => inputNote(e.target.value, name)}
            value={dataNote?.value}
          ></textarea>

          {errors?.[`catatan_${name}`] || errors?.[`catatan_${anotherName}`] ? (
            <p className='text-danger'>
              {errors?.[`catatan_${name}`] || errors?.[`catatan_${anotherName}`]}
            </p>
          ) : null}
        </div>
      )}
    </>
  )
}

const TypeProposalDocument: FC<Props> = ({
  radioButton,
  title,
  desc,
  file,
  onSelectedRadio,
  onInputNote,
  name,
  data,
  errors,
  fieldRefs,
  anotherName,
}) => {
  return (
    <TypeProposalContent
      radioButton={radioButton}
      title={title}
      desc={desc}
      file={file}
      onSelectedRadio={onSelectedRadio}
      onInputNote={onInputNote}
      name={name}
      data={data}
      errors={errors}
      fieldRefs={fieldRefs}
      anotherName={anotherName}
    />
  )
}

export default TypeProposalDocument
